export default "__VITE_ASSET__DrPikePR__"